module.exports = function anonymous(it
) {
var out='<section class="search-definition content hidden"> <div class="main-container"> <div class="row-fluid js-search-container"> <div class="span12 js-search-form-container"></div> </div> <div class="row-fluid"> <div class="span12 js-results-container results-container"></div> </div> </div></section>';return out;
}